import { Component, OnInit } from '@angular/core';
import { AuthManagerService } from '../../api/auth/auth-manager.service';
import { BroadcastService } from '../../common/services/broadcast.service';
import { DemoLoginModel } from '../../api/auth/models/demo-login.model';
import { finalize } from 'rxjs/operators';
import { Router } from '@angular/router';

@Component({
    selector: 'toro-demo',
    templateUrl: './demo.component.html',
    styleUrls: ['./demo.component.less']
})
export class DemoComponent implements OnInit {

    protected userName: string = '';
    protected password: string = '';
    protected isBusy = false;
    protected isInvalidLogin = false;

    private route: string;

    // =========================================================================================================================================================
    // Ctor
    // =========================================================================================================================================================

    constructor(private authManager: AuthManagerService,
                private broadcastService: BroadcastService,
                private router: Router
    ) { }

    ngOnInit() {
        const referer = this.router.url;

        switch (referer) {
            case '/spatialadjust/demo':
                this.route = '/spatialadjust';
                break;
            case '/demo':
                this.route = '/';
                break;
            default:
                setTimeout(() => this.router.navigateByUrl('/ah-snap'));
                break;
        }
    }

    // =========================================================================================================================================================
    // Event Handlers
    // =========================================================================================================================================================

    protected onSignIn(): void {
        this.isInvalidLogin = false;
        this.isBusy = true;

        this.authManager.demoLogin(new DemoLoginModel(this.userName, this.password))
            .pipe(finalize(() => this.isBusy = false))
            .subscribe({
                next: (success: boolean) => {
                    if (success) {
                        this.authManager.demoUserLoggedIn = true;
                        this.broadcastService.demoUserSignIn.next(true);

                        this.router.navigate([this.route]);
                    } else {
                        this.handleInvalidLogin();
                    }
                },
                error: () => {
                    this.handleInvalidLogin();
                }
            })

    }

    protected onKeyDown(event: KeyboardEvent): void {
        this.isInvalidLogin = false;
    }

    // =========================================================================================================================================================
    // Helper Methods
    // =========================================================================================================================================================

    private handleInvalidLogin(): void {
        this.isInvalidLogin = true;
        this.password = '';
    }

}
